import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Shows the most recent Pricelabs sync across all listings + a one-click "refresh now" button. */
export const PricelabsSyncBar = ({ listings, onSynced }) => {
  const { t } = useTranslation();
  const [syncing, setSyncing] = useState(false);

  const linked = listings.filter((l) => l.pricelabs_listing_id);
  if (linked.length === 0) return null;

  const lastSync = linked.map((l) => l.pricelabs_last_synced_at).filter(Boolean).sort().pop();
  const lastError = linked.find((l) => l.pricelabs_last_sync_error)?.pricelabs_last_sync_error;

  const syncNow = async () => {
    setSyncing(true);
    try {
      const r = await api.post("/admin/pricelabs/sync-all");
      const ok = (r.data.results || []).filter((x) => !x.error).length;
      const failed = (r.data.results || []).filter((x) => x.error);
      if (failed.length) toast.error(failed[0].error);
      else toast.success(t("admin.sync_done", { n: ok }));
      await onSynced();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Sync failed");
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="flex items-center gap-4 text-xs text-[#8C7A6B]" data-testid="pricelabs-sync-bar">
      <span data-testid="pricelabs-last-sync">
        {t("admin.last_sync")}: {lastSync ? new Date(lastSync).toLocaleString() : t("admin.never_synced")}
        <span className="opacity-60"> · {t("admin.sync_auto")}</span>
        {lastError && <span className="text-[#C86D53]"> · {lastError}</span>}
      </span>
      <button onClick={syncNow} disabled={syncing} data-testid="sync-prices-now-btn"
              className="btn-secondary text-xs inline-flex items-center gap-2 disabled:opacity-50">
        <RefreshCw className={`h-3.5 w-3.5 ${syncing ? "animate-spin" : ""}`} />
        {syncing ? t("admin.syncing") : t("admin.sync_prices_now")}
      </button>
    </div>
  );
};
